import { Stack, Typography, Paper, Link } from "@mui/material";
import { styled } from "@mui/system";
import { trackEvent } from "src/Amplitude";

const HelpContainer = styled(Paper)(() => ({
  padding: "24px",
  borderRadius: "20px",
  border: "1px solid #F5F3EF",
  backgroundColor: "#FFF",
  boxShadow: "none",
}));

const HelpHeader = styled(Typography)(() => ({
  fontFamily: "Roobert, sans-serif",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "20px",
  color: "#002035",
  marginBottom: "16px",
  paddingBottom: "16px",
  borderBottom: "1px solid #F5F3EF",
}));

const HelpRow = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 0",
}));

const HelpRowContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));

const HelpRowTitle = styled(Typography)(() => ({
  fontFamily: "Roobert, sans-serif",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "20px",
  color: "#002035",
}));

const HelpRowDescription = styled(Typography)(() => ({
  fontFamily: "Roobert, sans-serif",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  color: "#5C6469",
}));

const HelpButton = styled(Link)(() => ({
  display: "flex",
  padding: "8px 12px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  borderRadius: "20px",
  border: "1px solid #E5E9EB",
  backgroundColor: "#FFF",
  color: "#002035",
  fontFamily: "Roobert, sans-serif",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "20px",
  textDecoration: "none",
  whiteSpace: "nowrap",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#F8F9F9",
    textDecoration: "none",
  },
}));

const HelpButtonAction = styled("button")(() => ({
  display: "flex",
  padding: "8px 12px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  borderRadius: "20px",
  border: "1px solid #E5E9EB",
  backgroundColor: "#FFF",
  color: "#002035",
  fontFamily: "Roobert, sans-serif",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "20px",
  whiteSpace: "nowrap",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#F8F9F9",
  },
}));

const UsefulLinks = () => {
  const openIntercom = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const intercom = (window as any).Intercom;
    if (intercom) {
      intercom("show");
    }
  };

  const handleContactSupport = () => {
    trackEvent(`External_Link`, { link: "Chat with Support" }, "Settings");
    openIntercom();
  };

  return (
    <HelpContainer>
      <HelpHeader>Help</HelpHeader>
      <Stack spacing={0}>
        {/* Support articles */}
        <HelpRow>
          <HelpRowContent>
            <HelpRowTitle>Support articles</HelpRowTitle>
            <HelpRowDescription>
              Help on how to navigate our Portal, FAQs and your questions answered here
            </HelpRowDescription>
          </HelpRowContent>
          <HelpButton
            href="https://support.calebandbrown.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent(`External_Link`, { link: "Support articles" }, "Settings")}>
            View FAQs
          </HelpButton>
        </HelpRow>

        {/* Submit feedback */}
        <HelpRow>
          <HelpRowContent>
            <HelpRowTitle>Submit feedback</HelpRowTitle>
            <HelpRowDescription>
              Let us know what you like about our product or help us improve
            </HelpRowDescription>
          </HelpRowContent>
          <HelpButton
            href="https://form.asana.com/?k=grtl60BFDkt2fLC3BMPG9Q&d=538008531828845"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent(`External_Link`, { link: "Submit feedback" }, "Settings")}>
            Submit Feedback
          </HelpButton>
        </HelpRow>

        {/* Chat with Support */}
        <HelpRow>
          <HelpRowContent>
            <HelpRowTitle>Chat with Support</HelpRowTitle>
            <HelpRowDescription>Having trouble? Speak to someone</HelpRowDescription>
          </HelpRowContent>
          <HelpButtonAction onClick={handleContactSupport}>Contact Support</HelpButtonAction>
        </HelpRow>
      </Stack>
    </HelpContainer>
  );
};

export default UsefulLinks;
